import { render, staticRenderFns } from "./FamilyStaffChatHistoryDialog.vue?vue&type=template&id=1cbe7324&scoped=true"
import script from "./FamilyStaffChatHistoryDialog.vue?vue&type=script&lang=js"
export * from "./FamilyStaffChatHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./FamilyStaffChatHistoryDialog.vue?vue&type=style&index=0&id=1cbe7324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe7324",
  null
  
)

export default component.exports